<div class="dls-example-viewer">

  <!-- Toolbar (Header)-->
  <mat-toolbar class="dls-toolbar justify-content-between">

    <!-- Title -->
    <span class="text-wrap">
      {{title}}
    </span>

    <!-- Code block toggle button -->
    <span>
      <button
        aria-label="toggle example"
        atlas-icon-button
        (click)="toggleCodeBlock()">
        <mat-icon>code</mat-icon>
      </button>
    </span>
  </mat-toolbar>

  <!-- Content -->
  <div class="dls-content w-100" [ngClass]="{'p-3': !codeBlock, 'px-3 pb-3': codeBlock}">

    <!-- Tab group -->
    <div class="w-100" *ngIf="codeBlock">
      <atlas-tab-group [color]="color">
        <atlas-tab label="HTML">
          <ng-content select="[HTML]"></ng-content>
        </atlas-tab>
        <atlas-tab label="TS">
          <ng-content select="[TS]"></ng-content>
        </atlas-tab>
        <atlas-tab label="SCSS">
          <ng-content select="[SCSS]"></ng-content>
        </atlas-tab>
      </atlas-tab-group>
    </div>

    <!-- Code block divider -->
    <div class="d-block mb-3" *ngIf="codeBlock">
      <mat-divider [inset]="false" *ngIf="codeBlock" ></mat-divider>
    </div>

    <!-- Example content projection -->
    <div class="d-block">
      <ng-content select="[example]"></ng-content>
    </div>
  </div>
</div>
